import { API } from 'aws-amplify'

import {
  updateDgtPdOrderReasonCode
} from '../graphql/mutations'
import {
  reasonCodesByOrderId,
  getDgtPdOrderReasonCode
} from '../graphql/queries'
import { OrderReasonCode } from '../components/types'

export const getReasonCodes = async (orderId: string) : Promise<OrderReasonCode[]> => {
  const listResult: any = await API.graphql({
    query: reasonCodesByOrderId,
    variables: { 
      productionOrderId: orderId,
      filter: {
        _deleted: { ne: true }
      }
    }
  })
  const reasonCodes: OrderReasonCode[] = 
    listResult.data?.reasonCodesByOrderId.items
  reasonCodes.sort((a, b) => a.materialCode.localeCompare(b.materialCode))
  return reasonCodes
}

export const getReasonCode = async (id: string) : Promise<OrderReasonCode> => {
  const result: any = await API.graphql({
    query: getDgtPdOrderReasonCode,
    variables: { id }
  })
  return result.data?.getDgtPdOrderReasonCode
}

export const updateNewCode = async (id: string, newCodes: string, currentVersion: number) : Promise<OrderReasonCode> => {
  const updateResult: any = await API.graphql({
    query: updateDgtPdOrderReasonCode,
    variables: {
      input: {
        id,
        reasonCodes: newCodes,
        _version: currentVersion,
      }
    }
  })
  return updateResult.data?.updateDgtPdOrderReasonCode
}
